
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'ModalBottom',
  props: {
    buttonClose: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    },
    abovePreloader: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    }
  },
  emits: ['closeModal']
})
